import React from "react";
import { Mutation } from "react-apollo";
import DeleteIcon from "@material-ui/icons/Delete";
import { IconButton } from "@material-ui/core";

import {
  DELETE_AD_UNIT,
  FIND_ADUNITS_DOMAINS,
  FIND_ADUNITS_BY_PLUBLISHERID_DYNAMIC,
} from "../../../queries/adUnit";

function filteredData(selectedRows, adUnits, adUnitsList) {
  selectedRows.data.forEach(d => {
    const id = adUnitsList[d.dataIndex].id;
    adUnits = adUnits.filter(e => e.id !== id);
  });
  return adUnits;
}

const DeleteAdUnit = props => {
  const { selectedRows, adUnitsList } = props;
  return (
    <Mutation
      mutation={DELETE_AD_UNIT}
      update={(store, { data: { deleteAdUnit } }) => {
        const { findAdUnitsByPublisherId } = store.readQuery({
          query: FIND_ADUNITS_BY_PLUBLISHERID_DYNAMIC(deleteAdUnit.publisherId),
        });
        store.writeQuery({
          query: FIND_ADUNITS_BY_PLUBLISHERID_DYNAMIC(deleteAdUnit.publisherId),
          data: {
            findAdUnitsByPublisherId: filteredData(
              selectedRows,
              findAdUnitsByPublisherId,
              adUnitsList,
            ),
          },
        });
      }}
      refetchQueries={[{ query: FIND_ADUNITS_DOMAINS }]}
      awaitRefetchQueries={true}
    >
      {deleteAdUnit => (
        <div>
          <IconButton
            aria-label="delete"
            onClick={e => {
              e.preventDefault();
              selectedRows.data.forEach(d => {
                const slot = adUnitsList[d.dataIndex].slot;
                deleteAdUnit({ variables: { slot: slot } });
              });
            }}
          >
            <DeleteIcon />
          </IconButton>
        </div>
      )}
    </Mutation>
  );
};

export default DeleteAdUnit;
